<div class="flex flex-col gap-2" [formGroup]="pharmacyForm()">
  <label for="pharmacyCredit" class="text-[14px] font-[500] hover:cursor-pointer" i18n="@@pharmacyQuota">
    Quota (Credit Limit) (L.E)
    <span class="text-danger-text">*</span>
  </label>

  <input
    id="pharmacyCredit"
    type="text"
    inputmode="numeric"
    appThousandSeparator
    formControlName="pharmacyCredit"
    placeholder="Enter credit limit"
    i18n-placeholder="@@pharmacyQuotaPlaceholder"
    class="border-border bg-surface-subtle placeholder-text-gray hover-border-input-border focus-border-gray-strong rounded-[6px] border-[1px] px-3 py-2 text-[14px] focus:bg-white focus:outline-none"
    [class.border-red-500]="
      pharmacyForm().get('pharmacyCredit')?.invalid && pharmacyForm().get('pharmacyCredit')?.touched
    "
    [class.border-yellow-400]="
      pharmacyForm().get('pharmacyCredit')?.value === 0 && pharmacyForm().get('pharmacyCredit')?.touched
    " />

  <!-- Errors -->
  @if (pharmacyForm().get("pharmacyCredit")?.invalid && pharmacyForm().get("pharmacyCredit")?.touched) {
    <span class="text-xs text-red-600">
      @if (pharmacyForm().get("pharmacyCredit")?.errors?.["required"]) {
        <span i18n="@@creditLimitRequired">Credit Limit is required</span>
      } @else if (pharmacyForm().get("pharmacyCredit")?.errors?.["invalidFormat"]) {
        <span i18n="@@creditLimitInvalidFormat">Credit Limit must be a valid number</span>
      } @else if (
        pharmacyForm().get("pharmacyCredit")?.errors?.["negative"] ||
        pharmacyForm().get("pharmacyCredit")?.errors?.["min"]
      ) {
        <span i18n="@@creditLimitNegative">Credit Limit cannot be negative</span>
      } @else if (pharmacyForm().get("pharmacyCredit")?.errors?.["maxExceeded"]) {
        <span i18n="@@creditLimitMaxExceeded">Credit Limit cannot exceed 10,000,000.00 EGP</span>
      }
    </span>
  }

  <!-- Zero warning (not an error, just a warning) -->
  @if (
    pharmacyForm().get("pharmacyCredit")?.value === 0 &&
    pharmacyForm().get("pharmacyCredit")?.touched &&
    pharmacyForm().get("pharmacyCredit")?.valid
  ) {
    <span class="text-xs text-yellow-600" i18n="@@creditLimitZeroWarning">
      Warning: Setting credit limit to zero will prevent this pharmacy from placing orders on credit
    </span>
  }
</div>
